import React, { Component } from 'react';
import UserContext from './UserContext';
import switchToMydlinkLang from '../../helper/switchToMydlinkLang';
import { getCookie } from '../../helper/cookieClient';

// TrustArc's own locale codes, which don't always match our internal language codes
const trustArcLanguageMap = {
  zh_TW: 'zh_HANT',
  zh_CN: 'zh_HANS'
};

class UserContextProvider extends Component {
  constructor(props) {
    super(props);

    const defaultLang =
      getCookie('lang') ||
      navigator.language ||
      navigator.browserLanguage ||
      'en';
    const language = switchToMydlinkLang(defaultLang);

    this.state = {
      name: '',
      email: '',
      changeLanguage: this.changeLanguage,
      setUserInfo: this.setUserInfo,
      language
    };
  }

  componentDidMount() {
    this.loadTrustArcScript();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.language !== this.state.language) {
      this.loadTrustArcScript();
    }
  }

  componentWillUnmount() {
    const teconsentDiv = document.getElementById('teconsent');
    if (teconsentDiv) {
      teconsentDiv.remove();
    }
  }

  // Loads/reloads the TrustArc consent banner for the current language.
  // The banner itself is hidden; the footer's Cookie Preferences link reopens it.
  loadTrustArcScript = () => {
    const { language } = this.state;

    const existingDiv = document.getElementById('teconsent');
    if (existingDiv) {
      existingDiv.remove();
    }

    const cookieCode = trustArcLanguageMap[language] || language;
    const privacyPolicyUrl = 'https://sso.dlink.com/privacy-policy';

    const teconsentDiv = document.createElement('div');
    teconsentDiv.id = 'teconsent';
    teconsentDiv.style.display = 'none';
    teconsentDiv.style.position = 'absolute';
    teconsentDiv.style.left = '-9999px';

    const script = document.createElement('script');
    script.async = true;
    script.src = `//consent.trustarc.com/notice?domain=mydlink.com&c=teconsent&js=nj&noticeType=bb&text=true&language=${cookieCode}&gtm=1&privacypolicylink=${encodeURIComponent(
      privacyPolicyUrl
    )}`;
    script.crossOrigin = '';

    teconsentDiv.appendChild(script);
    document.body.appendChild(teconsentDiv);
  };

  changeLanguage = language => {
    this.setState({
      language: switchToMydlinkLang(language)
    });
  };

  setUserInfo = (name, email) => {
    this.setState({
      name,
      email
    });
  };

  render() {
    return (
      <UserContext.Provider value={this.state}>
        {this.props.children}
      </UserContext.Provider>
    );
  }
}

export default UserContextProvider;



// WEBPACK FOOTER //
// ./src/components/context/UserContextProvider.js